import axios from '@/utils/axios';

export default {
    runAssignment(data) {
      return axios.post(`/template/${data.id}/box-detect`, data.box);
    },
  };